import { useState } from "react";
import { Eye, EyeSlash } from "@phosphor-icons/react";

export default function PasswordField({ value, onChange, placeholder, required = true, minLength, dataTestId, label }) {
  const [show, setShow] = useState(false);
  return (
    <div>
      {label && <label className="text-xs text-[#A3A3A3] uppercase tracking-wider font-bold mb-2 block">{label}</label>}
      <div className="relative">
        <input
          data-testid={dataTestId}
          type={show ? "text" : "password"}
          required={required}
          minLength={minLength}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className="w-full bg-[#1A1A1A] border-2 border-[#333] h-14 text-lg text-white rounded-md pl-4 pr-14 focus:border-[#FFD600] focus:outline-none"
        />
        <button
          type="button"
          onClick={() => setShow((s) => !s)}
          data-testid={`${dataTestId}-toggle`}
          aria-label={show ? "Nascondi password" : "Mostra password"}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-[#A3A3A3] hover:text-[#FFD600] p-2"
        >
          {show ? <EyeSlash size={22} weight="bold" /> : <Eye size={22} weight="bold" />}
        </button>
      </div>
    </div>
  );
}
